import { render, staticRenderFns } from "./UserConfiguration.vue?vue&type=template&id=5adb1021&scoped=true"
import script from "./UserConfiguration.vue?vue&type=script&lang=js"
export * from "./UserConfiguration.vue?vue&type=script&lang=js"
import style0 from "./UserConfiguration.vue?vue&type=style&index=0&id=5adb1021&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb1021",
  null
  
)

export default component.exports